import Line from './component';
import { lineTool } from '../shared/line';

export const tool = lineTool('line', Line);
